/* Science Fitness — product page interactions (vanilla, no framework).
   Loaded only on the product template by sections/main-product.liquid.
   Enhances a page that already works without JS (native form submit). */
(function () {
  "use strict";

  var root = document.querySelector("[data-product]");
  if (!root) return;

  /* ---- Variant data (money pre-formatted in Liquid) ---- */
  var variants = [];
  var json = root.querySelector("[data-variant-json]");
  if (json) {
    try { variants = JSON.parse(json.textContent) || []; } catch (e) { variants = []; }
  }
  function variantById(id) {
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  var picker = root.querySelector("[data-variant-picker]");
  var accent = picker ? picker.getAttribute("data-accent") : "";
  var select = root.querySelector("[data-variant-select]");
  var priceEl = root.querySelector("[data-price]");
  var compareEl = root.querySelector("[data-compare]");
  var barPriceEl = root.querySelector("[data-bar-price]");
  var atc = root.querySelector("[data-atc]");
  var atcText = root.querySelector("[data-atc-text]");
  var mainImg = root.querySelector("[data-gallery-main]");
  var thumbs = root.querySelectorAll("[data-gallery-thumb]");

  /* ---- Gallery: show a media by its id (used by thumbs + variant change) ----
     Swaps used to assign an un-fetched 1400px URL straight to src, so every
     first view was a network round-trip painted progressively (visible lag +
     flash). Now: all full-size images are warmed in the background once the
     page is idle, and a swap only happens after the target image is fully
     decoded — instant when cached, and never a partial paint. */
  var preloaded = {};
  function preload(url) {
    if (!url) return null;
    if (!preloaded[url]) {
      var im = new Image();
      im.decoding = "async";
      im.src = url;
      preloaded[url] = im;
    }
    return preloaded[url];
  }
  function warmGallery() {
    thumbs.forEach(function (t) { preload(t.getAttribute("data-full")); });
  }
  if ("requestIdleCallback" in window) {
    requestIdleCallback(warmGallery, { timeout: 2000 });
  } else {
    setTimeout(warmGallery, 500);
  }

  /* Directional slide between images: the incoming image is layered above,
     slid in with transforms (never width/left — those reflow), then swapped
     into normal flow. dir +1 = came from a later thumb (enter from right),
     -1 = earlier (from left), 0 = no motion (fallback + reduced motion). */
  var swapToken = 0;
  var pendingFinish = null;
  var SLIDE_EASE = "transform 0.45s cubic-bezier(0.22, 1, 0.36, 1)";
  function swapMain(url, dir) {
    if (!mainImg || !url || mainImg.src === url) return;
    var im = preload(url);
    var token = ++swapToken; // a newer click supersedes an in-flight swap
    var reduce = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var apply = function () {
      if (token !== swapToken) return;
      if (pendingFinish) pendingFinish(); // settle any slide still in flight
      if (!dir || reduce) { mainImg.src = url; return; }
      var old = mainImg;
      var next = old.cloneNode(false);
      next.src = url;
      next.style.position = "absolute";
      next.style.inset = "0";
      next.style.transition = "none";
      next.style.transform = "translateX(" + (dir > 0 ? "102%" : "-102%") + ")";
      old.parentNode.appendChild(next);
      next.getBoundingClientRect(); // commit the start position
      next.style.transition = SLIDE_EASE;
      old.style.transition = SLIDE_EASE;
      next.style.transform = "translateX(0)";
      old.style.transform = "translateX(" + (dir > 0 ? "-102%" : "102%") + ")";
      var done = false;
      pendingFinish = function () {
        if (done) return;
        done = true;
        // promote the incoming image to normal flow, drop the old one
        next.style.position = next.style.inset = "";
        next.style.transition = next.style.transform = "";
        if (old.parentNode) old.parentNode.removeChild(old);
        mainImg = next;
        pendingFinish = null;
      };
      next.addEventListener("transitionend", pendingFinish);
      setTimeout(pendingFinish, 550); // safety net if transitionend is lost
    };
    if (im.decode) {
      im.decode().then(apply, apply);
    } else if (im.complete) {
      apply();
    } else {
      im.onload = apply;
      im.onerror = apply;
    }
  }
  function showMedia(mediaId) {
    if (!mediaId) return;
    var url = null, newIndex = -1, oldIndex = -1;
    thumbs.forEach(function (t, i) {
      if (t.getAttribute("aria-current") === "true") oldIndex = i;
      if (String(t.getAttribute("data-media-id")) === String(mediaId)) {
        newIndex = i;
        url = t.getAttribute("data-full");
      }
    });
    if (newIndex < 0) return;
    thumbs.forEach(function (t, i) {
      t.setAttribute("aria-current", i === newIndex ? "true" : "false");
      if (i === newIndex && t.scrollIntoView) {
        // centre the active thumb: the strip auto-advances as you approach
        // either end, so the next thumbs are always already in view
        t.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
      }
    });
    var dir = oldIndex < 0 || newIndex === oldIndex ? 0 : (newIndex > oldIndex ? 1 : -1);
    swapMain(url, dir);
  }
  /* ---- Thumb-strip edge fades: only fade an edge with content beyond it ---- */
  var strip = root.querySelector("[data-gallery-thumbs]");
  if (strip) {
    var updateFade = function () {
      var max = strip.scrollWidth - strip.clientWidth;
      strip.classList.toggle("fade-l", strip.scrollLeft > 4);
      strip.classList.toggle("fade-r", strip.scrollLeft < max - 4);
    };
    strip.addEventListener("scroll", updateFade, { passive: true });
    window.addEventListener("resize", updateFade);
    updateFade();
  }

  /* ---- Main-image prev/next arrows (wrap around) ---- */
  function stepGallery(delta) {
    if (!thumbs.length) return;
    var cur = 0;
    thumbs.forEach(function (t, i) {
      if (t.getAttribute("aria-current") === "true") cur = i;
    });
    var n = thumbs.length;
    var target = (cur + delta + n) % n;
    showMedia(thumbs[target].getAttribute("data-media-id"));
  }
  var prevBtn = root.querySelector("[data-gallery-prev]");
  var nextBtn = root.querySelector("[data-gallery-next]");
  if (prevBtn) prevBtn.addEventListener("click", function () { stepGallery(-1); });
  if (nextBtn) nextBtn.addEventListener("click", function () { stepGallery(1); });

  thumbs.forEach(function (t) {
    t.addEventListener("click", function () {
      showMedia(t.getAttribute("data-media-id"));
    });
    // belt-and-braces for slow connections: make sure the image is on its way
    // the moment intent shows, even if the idle warm-up hasn't reached it yet
    t.addEventListener("pointerenter", function () {
      preload(t.getAttribute("data-full"));
    });
  });

  /* ---- Apply the current variant to price / availability / gallery / URL ---- */
  function selectVariant(id, updateMedia) {
    var v = variantById(id);
    if (!v) return;

    if (priceEl) priceEl.innerHTML = v.price;
    if (compareEl) {
      if (v.compare_at_price) {
        compareEl.innerHTML = v.compare_at_price;
        compareEl.classList.remove("hidden");
      } else {
        compareEl.classList.add("hidden");
      }
    }
    if (barPriceEl) barPriceEl.textContent = String(v.price).replace(/<[^>]*>/g, "");

    /* sale badge follows the selected pack — each pack has its own discount */
    root.querySelectorAll("[data-sale-badge]").forEach(function (badge) {
      var pctEl = badge.querySelector("[data-sale-badge-pct]");
      if (v.sale_pct && v.sale_pct > 0) {
        if (pctEl) pctEl.textContent = v.sale_pct;
        badge.classList.remove("hidden");
      } else {
        badge.classList.add("hidden");
      }
    });

    if (atc) {
      atc.disabled = !v.available;
      if (atcText) {
        atcText.textContent = v.available
          ? atc.getAttribute("data-add-label")
          : atc.getAttribute("data-sold-label");
      }
    }

    if (updateMedia && v.media_id) showMedia(v.media_id);

    try {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url.toString());
    } catch (e) { /* no-op */ }
  }

  /* ---- Variant pills (radios) ---- */
  if (picker) {
    var radios = picker.querySelectorAll("[data-variant-radio]");
    function paintPills() {
      radios.forEach(function (r) {
        var span = r.nextElementSibling;
        if (!span) return;
        if (r.checked && accent) {
          span.style.borderColor = accent;
          span.style.backgroundColor = accent + "22";
        } else {
          span.style.borderColor = "";
          span.style.backgroundColor = "";
        }
      });
    }
    radios.forEach(function (r) {
      r.addEventListener("change", function () {
        if (!r.checked) return;
        paintPills();
        selectVariant(r.value, true);
      });
    });
    paintPills();
  }

  /* ---- Variant select (fallback) ---- */
  if (select) {
    select.addEventListener("change", function () {
      selectVariant(select.value, true);
    });
  }

  /* ---- Quantity stepper ---- */
  var qty = root.querySelector("[data-qty-input]");
  var minus = root.querySelector("[data-qty-minus]");
  var plus = root.querySelector("[data-qty-plus]");
  function step(delta) {
    if (!qty) return;
    var n = parseInt(qty.value, 10);
    if (isNaN(n)) n = 1;
    n = Math.max(1, n + delta);
    qty.value = n;
  }
  if (minus) minus.addEventListener("click", function () { step(-1); });
  if (plus) plus.addEventListener("click", function () { step(1); });

  /* ---- Mobile sticky add-to-cart bar (show once the buy-box CTA scrolls off) ---- */
  var bar = root.querySelector("[data-atc-bar]");
  var anchor = root.querySelector("[data-atc-anchor]");
  if (bar && anchor && "IntersectionObserver" in window) {
    var barIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          bar.classList.toggle("is-visible", !e.isIntersecting);
        });
      },
      { rootMargin: "0px 0px -40px 0px", threshold: 0 }
    );
    barIO.observe(anchor);
  }

  /* ---- Buy-it-now label wrap ----
     Shopify renders the dynamic checkout button, so Liquid can't wrap its text
     the way our own CTAs are. Wrap it here so the shared arrow-reveal CSS can
     push the label; the observer re-wraps if Shopify's wallet JS re-renders. */
  var pb = root.querySelector(".shopify-payment-button");
  if (pb) {
    var wrapPbLabel = function () {
      var btn = pb.querySelector(".shopify-payment-button__button--unbranded");
      if (!btn || btn.querySelector("[data-pb-label]")) return;
      var span = document.createElement("span");
      span.setAttribute("data-pb-label", "");
      while (btn.firstChild) span.appendChild(btn.firstChild);
      btn.appendChild(span);
    };
    wrapPbLabel();
    if ("MutationObserver" in window) {
      new MutationObserver(wrapPbLabel).observe(pb, { childList: true, subtree: true });
    }
  }

  /* ---- Sale countdown ----
     Counts down to the real deadline in custom.sale_ends_at and then removes
     itself. It deliberately does NOT loop back and restart: a timer that keeps
     resetting states the offer ends when it doesn't, which is a banned
     practice under the DMCC Act 2024. See docs/SALE-COUNTDOWN.md. */
  var cd = root.querySelector("[data-sale-countdown]");
  if (cd) {
    var endsAt = new Date(cd.getAttribute("data-ends")).getTime();
    var cdValue = cd.querySelector("[data-sale-countdown-value]");
    var hideCd = function () {
      cd.classList.add("hidden");
      cd.classList.remove("inline-flex");
    };
    var isDaily = cd.getAttribute("data-daily") === "true";
    // recurring mode: the countdown restarts every N hours from the anchor time
    var cycleHours = parseFloat(cd.getAttribute("data-cycle")) || 12;
    var CYCLE_MS = cycleHours * 60 * 60 * 1000;
    var pad = function (n) { return n < 10 ? "0" + n : String(n); };

    // two independently-animating digit groups, so minutes can tick over
    // without the hours flinching
    var parts = {};
    if (cdValue) {
      cdValue.innerHTML =
        '<span data-cd-part="h"></span>H ' +
        '<span data-cd-part="m"></span>M ' +
        '<span data-cd-part="s"></span>S';
      parts.h = cdValue.querySelector('[data-cd-part="h"]');
      parts.m = cdValue.querySelector('[data-cd-part="m"]');
      parts.s = cdValue.querySelector('[data-cd-part="s"]');
    }
    var setPart = function (el, text) {
      if (!el || el.textContent === text) return;
      var first = el.textContent === "";
      el.textContent = text;
      if (first) return; // no flip on initial paint
      el.classList.remove("is-ticking");
      void el.offsetWidth; // restart the animation
      el.classList.add("is-ticking");
    };

    var tickCd = function () {
      if (isNaN(endsAt)) { hideCd(); return; }
      var ms = endsAt - Date.now();
      // recurring mode: step the target forward a whole number of cycles until
      // it is in the future again (handles a tab left open, or a stale anchor)
      if (isDaily && ms <= 0) {
        var behind = Math.ceil((Date.now() - endsAt) / CYCLE_MS);
        endsAt += behind * CYCLE_MS;
        ms = endsAt - Date.now();
      }
      // a one-off sale end that has passed hides; distance is never a reason
      // to hide (that is what made it vanish for a far-off date)
      if (ms <= 0) { hideCd(); return; }
      var secs = Math.floor(ms / 1000);
      setPart(parts.h, pad(Math.floor(secs / 3600)));
      setPart(parts.m, pad(Math.floor((secs % 3600) / 60)));
      setPart(parts.s, pad(secs % 60));
      cd.classList.remove("hidden");
      cd.classList.add("inline-flex");
      // re-align to the next whole second so the seconds never appear to stall
      // or skip; setPart only touches the DOM for digits that actually changed
      setTimeout(tickCd, 1000 - (Date.now() % 1000));
    };
    tickCd();
  }

  /* ---- Related products (Shopify recommendations, fetched with intent) ---- */
  var rec = document.querySelector("[data-product-recommendations]");
  if (rec && rec.dataset.url && rec.innerHTML.trim() === "") {
    fetch(rec.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, "text/html");
        var incoming = doc.querySelector("[data-product-recommendations]");
        if (incoming) rec.innerHTML = incoming.innerHTML;
      })
      .catch(function () { /* leave empty on failure */ });
  }
})();
